import { useContext } from "react";
import { BeneficiaryITContext } from "../../context/BeneficiaryIT.context";
import SelectTypeBeneficiaries from "./SelectTypeBeneficiaries";
import BeneficiariesScreen from "./BeneficiariesScreen";

const BeneficiaryIT = () => {
  const { isSelectBeneficiaryType, beneficiaryType } =
    useContext(BeneficiaryITContext);
  return (
    <>
      {isSelectBeneficiaryType === "Free designation" ? (
        <BeneficiariesScreen />
      ) : (
        <SelectTypeBeneficiaries />
      )}
    </>
  );
};

export default BeneficiaryIT;
